import React from 'react';
import logo from '../assets/sbb-logo.jpeg';

export function Logo({ size = 36 }) {
  return <img src={logo} alt="SBB Software Engineer" style={{ width: size, height: size }} />;
}
